<div class="guide-overlay" (click)="closeGuide()">
    <div class="guide-modal" (click)="$event.stopPropagation()">
        <div class="guide-modal__header">
            <span class="guide-modal__title-top">{{ currentStepIndex === 0 ? 'Customize Widgets' : 'How does this work?'
                }}</span>
            <div class="guide-modal__skip-container" (click)="skip()">
                <span class="skip-text">Skip</span>
            </div>
        </div>

        <!-- Illustration Area (Hidden for Intro Step) -->
        <div class="guide-modal__body" [style.gap.px]="currentStep.iconType === 'intro' ? 24 : 16">
            <div class="illustration-area" *ngIf="currentStep.iconType !== 'intro'">
                <div class="illustration-bg"></div>


                <!-- Step: Customize Widgets (Action) -->
                <ng-container *ngIf="currentStep.iconType === 'customize'">
                    <!-- Mock Customize Widgets Chip -->
                    <div class="customize-chip" style="position: absolute; left: 120px; top: 90px;">
                        <div class="customize-chip-icon">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round">
                                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                            </svg>
                        </div>
                        <div class="customize-chip-text">Customize Widgets</div>
                    </div>

                    <!-- Highlight Ring -->
                    <div class="highlight-ring" style="left: 144px; top: 70px; position: absolute;">
                        <div class="ring-inner"></div>
                    </div>
                </ng-container>

                <!-- Step: Drag and Drop -->
                <ng-container *ngIf="currentStep.iconType === 'drag'">
                    <div class="drag-mock-container">
                        <!-- Static Card -->
                        <div class="mini-widget static">
                            <div class="line sm"></div>
                            <div class="line lg"></div>
                        </div>
                        <!-- Draggable Card (Lifted) -->
                        <div class="mini-widget draggable">
                            <div class="line sm"></div>
                            <div class="line lg"></div>
                            <div class="drag-cursor">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="white" stroke="black"
                                    stroke-width="2">
                                    <path d="M5.5 1L2 14.5L7.5 12.5L10.5 19.5L13.5 18L10.5 11L16 11L5.5 1Z"></path>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div class="highlight-ring ring-drag">
                        <div class="ring-inner"></div>
                    </div>
                </ng-container>

                <!-- Step: Add Widgets -->
                <ng-container *ngIf="currentStep.iconType === 'add'">
                    <div
                        style="position: relative; height: 220px; display: flex; align-items: center; justify-content: center;">
                        <div
                            style="padding: 18px 36px; background: linear-gradient(357deg, #E7733A 50%, #ECB53E 75%); box-shadow: 0px -2px 0.5px rgba(0, 0, 0, 0.25) inset; border-radius: 55px; font-size: 14px; font-weight: 600; color: white;">
                            Add Widgets
                        </div>
                        <div
                            style="position: absolute; width: 80px; height: 80px; padding: 8px; border-radius: 40px; outline: 1.5px #52A8FB solid; outline-offset: -1.5px; display: flex; align-items: center; justify-content: center;">
                            <div style="width: 64px; height: 64px; border-radius: 999px; border: 3px #52A8FB solid;">
                            </div>
                        </div>
                    </div>
                </ng-container>

                <!-- Step: Pick a Widget -->
                <ng-container *ngIf="currentStep.iconType === 'pick'">
                    <div class="pick-widget-mock" style="position: relative; width: 100%; height: 100%;">
                        <!-- Placeholder widgets -->
                        <div class="placeholder-widget"
                            style="width: 120px; height: 160px; left: 58px; top: 30px; position: absolute;">
                        </div>
                        <div class="placeholder-widget"
                            style="width: 120px; height: 160px; left: 58px; top: 202px; position: absolute;">
                        </div>
                        <div class="placeholder-widget"
                            style="width: 120px; height: 160px; left: 190px; top: 30px; position: absolute;">
                        </div>
                        <div class="placeholder-widget"
                            style="width: 120px; height: 160px; left: 190px; top: 202px; position: absolute;">
                        </div>

                        <!-- + Button 1 -->
                        <div class="add-button-mock"
                            style="padding: 2px; left: 142px; top: 42px; position: absolute; display: inline-flex; align-items: center; justify-content: center;">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2">
                                <path d="M12 5v14" />
                                <path d="M5 12h14" />
                            </svg>
                        </div>

                        <!-- + Button 2 -->
                        <div class="add-button-mock"
                            style="padding: 2px; left: 274px; top: 42px; position: absolute; display: inline-flex; align-items: center; justify-content: center;">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2">
                                <path d="M12 5v14" />
                                <path d="M5 12h14" />
                            </svg>
                        </div>

                        <!-- Ring on + Button 1 -->
                        <div class="highlight-ring" style="left: 114px; top: 14px; position: absolute;">
                            <div class="ring-inner"></div>
                        </div>
                    </div>
                </ng-container>

                <!-- Step: Resize Widgets -->
                <ng-container *ngIf="currentStep.iconType === 'resize'">
                    <!-- AI Chat Card Base -->
                    <div class="mock-widget-card"
                        style="width: 168px; height: 180px; left: 100px; top: 20px; position: absolute;">
                        <!-- Content -->
                        <div
                            style="flex:1; padding: 12px; display:flex; flex-direction:column; justify-content: space-between;">
                            <div class="mock-content-title">Have questions about your Finances?</div>
                            <!-- Search Btn -->
                            <div
                                style="border-radius: 40px; background: linear-gradient(357deg, #E7733A 50%, #ECB53E 75%); color: white; padding: 10px; display:flex; justify-content:center; align-items:center; gap:8px; font-size:14px; font-weight:600;">
                                Search →
                            </div>
                            <div class="resize-handle"></div>
                        </div>

                    </div>

                    <!-- Ring on Bottom Right Corner -->
                    <div class="highlight-ring" style="left: 220px; top: 160px; position: absolute;">
                        <div class="ring-inner"></div>
                    </div>
                </ng-container>

                <!-- Step: Manage Widgets (Context Menu for Size and Delete) -->
                <ng-container *ngIf="currentStep.iconType === 'manageEdit'">
                    <!-- Widget Mock -->
                    <div class="mock-widget-card" style="width: 168px; height: 216px; left: 40px; top: 10px;">
                        <!-- Header -->
                        <div class="mock-widget-header">
                            <div class="mock-widget-title">SAVINGS PLANS</div>
                            <div class="mock-icon-btn">
                                <svg width="16" height="16" viewBox="0 0 24 24">
                                    <path
                                        d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39 .39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
                                </svg>
                            </div>
                        </div>
                        <!-- Content -->
                        <div class="mock-widget-content">
                            <div style="display: flex; align-items: center; gap: 4px;" class="mock-label-text">
                                <div class="mock-avatar">R</div>
                                Retirement
                            </div>
                            <div class="mock-large-text">₹700,425.35</div>
                            <div class="mock-sub-text">SAVED</div>
                            <div class="mock-label-text">DAILY GOAL ₹600,000</div>
                            <!-- Progress bar mock -->
                            <div class="mock-progress-bar">
                                <div class="mock-progress-fill" style="width: 40%;"></div>
                            </div>
                            <div class="mock-label-text">ACHIEVED · 40%</div>
                        </div>
                    </div>



                    <!-- Ring on Pencil Icon -->
                    <div class="highlight-ring" style="left: 180px; top: -2px; position: absolute;">
                        <div class="ring-inner"></div>
                    </div>
                </ng-container>

                <!-- Step: Manage Widgets (Context Menu for Size and Delete) -->
                <ng-container *ngIf="currentStep.iconType === 'manage'">
                    <!-- Widget Mock -->
                    <div class="mock-widget-card"
                        style="width: 168px; height: 216px; left: 40px; top: 10px; position: absolute;">
                        <!-- Header -->
                        <div class="mock-widget-header">
                            <div class="mock-widget-title">SAVINGS PLANS</div>
                            <div class="mock-icon-btn">
                                <svg width="16" height="16" viewBox="0 0 24 24">
                                    <path
                                        d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39 .39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
                                </svg>
                            </div>
                        </div>
                        <!-- Content -->
                        <div class="mock-widget-content">
                            <div style="display: flex; align-items: center; gap: 4px;" class="mock-label-text">
                                <div class="mock-avatar">R</div>
                                Retirement
                            </div>
                            <div class="mock-large-text">₹700,425.35</div>
                            <div class="mock-sub-text">SAVED</div>
                            <div class="mock-label-text">DAILY GOAL ₹600,000</div>
                            <!-- Progress bar mock -->
                            <div class="mock-progress-bar">
                                <div class="mock-progress-fill" style="width: 40%;"></div>
                            </div>
                            <div class="mock-label-text">ACHIEVED · 40%</div>
                        </div>
                    </div>

                    <!-- Context Menu Mock -->
                    <div class="context-menu-mock" style="left: 120px; top: 55px; position: absolute;">
                        <div class="edit-section">
                            <div class="header-item">
                                <div class="icon-box">
                                    <svg width="16" height="16" viewBox="0 0 24 24">
                                        <path
                                            d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39 .39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
                                    </svg>
                                </div>
                                <div class="label">Edit Widget</div>
                            </div>
                            <div class="separator"></div>
                            <div class="size-item">
                                <div class="icon-box">
                                    <div class="size-icon small">
                                        <div class="rect"></div>
                                        <div class="rect"></div>
                                        <div class="rect"></div>
                                        <div class="rect"></div>
                                    </div>
                                </div>
                                <div class="label">Small Size</div>
                            </div>
                            <div class="size-item">
                                <div class="icon-box">
                                    <div class="size-icon medium">
                                        <div class="rect"></div>
                                        <div class="rect"></div>
                                    </div>
                                </div>
                                <div class="label">Medium Size</div>
                            </div>
                            <div class="size-item">
                                <div class="icon-box">
                                    <div class="size-icon large">
                                        <div class="rect"></div>
                                    </div>
                                </div>
                                <div class="label">Large Size</div>
                            </div>
                            <div class="size-item">
                                <div class="icon-box">
                                    <div class="size-icon xlarge">
                                        <div class="rect"></div>
                                    </div>
                                </div>
                                <div class="label">Extra Large</div>
                            </div>
                            <div class="separator"></div>
                            <div class="size-item delete-item">
                                <div class="icon-box">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#FF4D4D"
                                        stroke-width="2">
                                        <path d="M3 6h18" />
                                        <path
                                            d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" />
                                    </svg>
                                </div>
                                <div class="delete-label label">Delete Widget</div>
                            </div>
                        </div>
                    </div>

                    <!-- Ring on Pencil Icon -->
                    <div class="highlight-ring" style="left: 140px; top: -2px; position: absolute;">
                        <div class="ring-inner"></div>
                    </div>
                </ng-container>
            </div>

            <!-- Text Content -->
            <div class="text-content">
                <h2 class="text-title">{{ currentStep.title }}</h2>
                <p class="text-desc">{{ currentStep.description }}</p>
            </div>

            <!-- Footer Navigation -->
            <div class="modal-footer"
                [class.centered]="currentStepIndex === 0 || currentStepIndex === steps.length - 1">
                <button *ngIf="currentStepIndex > 0" class="footer-btn-back" (click)="prevStep()">Back</button>
                <button class="footer-btn-primary"
                    [class.full-btn]="currentStepIndex === 0 || currentStepIndex === steps.length - 1"
                    (click)="nextStep()">
                    {{ currentStepIndex === 0 ? 'Start Training' : (currentStepIndex === steps.length - 1 ? 'Start
                    using' : 'Next Step') }}
                </button>
            </div>
        </div>
    </div>
</div>